//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import Y477FT from "../../../Media/Image/037.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Tarihçe : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "2010 Yılında, Elektriği Sadece Taşımakla Kalmayıp Geleceğide Şekillendirme Hedefi İle Yola Çıktık."
        //Element
        let URL = "https://temaselektrik.com/tarihce"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Tarihçe"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "1998'den Bugüne ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Kablolardan"
                                        ),
                                        //Element
                                        " Geleceğe"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "1998 Yılında, Elektriği Sadece Taşımakla Kalmayıp Geleceğide Şekillendirme Hedefi İle Yola Çıktık. Küçük Bir Ekiple Başladığımız İlk Adımlar, Kısa Sürede Kamu Kurumları ve KOBİ’lerde Güvenilir Projelere Dönüştü.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bizim İçin Her Proje Yalnızca Bir İş Değil; Geleceğe Bağlanan Sağlam Bir Yatırım Oldu. 2012’ten İtibaren Sanayi Tesisleri ve Büyük Çlçekli Projelerde de Adımızı Duyurduk, Modern Uygulamalar ve İnovatif Çözümlerle Sınırlarımızı Genişlettik."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Bugün, 27 Yılı Aşkın Tecrübemiz ve Yenilikçi Yaklaşımımızla, Enerjiyi Güvenle Taşıyan, Sürdürülebilir ve Değer Üreten Projelerle Sektörde Saygın Bir Marka Olduk."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Tarihçe", title: "Tarihçe", src: Y477FT, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;